/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Achievementseyebrow1Inputs */

const id_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemajuan`)
};

const ms_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemajuan`)
};

const da_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fremskridt`)
};

const de_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortschritt`)
};

const en_us2_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression`)
};

const es_es2_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresión`)
};

const es_mx2_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresión`)
};

const fil_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso`)
};

const fr_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression`)
};

const it_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressione`)
};

const hu_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Előrehaladás`)
};

const nl_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voortgang`)
};

const no_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fremdrift`)
};

const pl_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresja`)
};

const pt_br2_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressão`)
};

const pt_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressão`)
};

const ro_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresie`)
};

const fi_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edistyminen`)
};

const sv_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Framsteg`)
};

const vi_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiến trình`)
};

const tr_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlerleme`)
};

const cs_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postup`)
};

const bg_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Напредък`)
};

const ru_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прогресс`)
};

const uk_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прогрес`)
};

const ar_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقدم`)
};

const hi_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रगति`)
};

const th_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความคืบหน้า`)
};

const ja_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進行状況`)
};

const zh_cn2_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进度`)
};

const zh_hant1_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進度`)
};

const ko_sandboxes_achievementseyebrow1 = /** @type {(inputs: Sandboxes_Achievementseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`진행`)
};

/**
* | output |
* | --- |
* | "Progression" |
*
* @param {Sandboxes_Achievementseyebrow1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_achievementseyebrow1 = /** @type {((inputs?: Sandboxes_Achievementseyebrow1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Achievementseyebrow1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_achievementseyebrow1(inputs)
	if (locale === "ms") return ms_sandboxes_achievementseyebrow1(inputs)
	if (locale === "da") return da_sandboxes_achievementseyebrow1(inputs)
	if (locale === "de") return de_sandboxes_achievementseyebrow1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_achievementseyebrow1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_achievementseyebrow1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_achievementseyebrow1(inputs)
	if (locale === "fil") return fil_sandboxes_achievementseyebrow1(inputs)
	if (locale === "fr") return fr_sandboxes_achievementseyebrow1(inputs)
	if (locale === "it") return it_sandboxes_achievementseyebrow1(inputs)
	if (locale === "hu") return hu_sandboxes_achievementseyebrow1(inputs)
	if (locale === "nl") return nl_sandboxes_achievementseyebrow1(inputs)
	if (locale === "no") return no_sandboxes_achievementseyebrow1(inputs)
	if (locale === "pl") return pl_sandboxes_achievementseyebrow1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_achievementseyebrow1(inputs)
	if (locale === "pt") return pt_sandboxes_achievementseyebrow1(inputs)
	if (locale === "ro") return ro_sandboxes_achievementseyebrow1(inputs)
	if (locale === "fi") return fi_sandboxes_achievementseyebrow1(inputs)
	if (locale === "sv") return sv_sandboxes_achievementseyebrow1(inputs)
	if (locale === "vi") return vi_sandboxes_achievementseyebrow1(inputs)
	if (locale === "tr") return tr_sandboxes_achievementseyebrow1(inputs)
	if (locale === "cs") return cs_sandboxes_achievementseyebrow1(inputs)
	if (locale === "bg") return bg_sandboxes_achievementseyebrow1(inputs)
	if (locale === "ru") return ru_sandboxes_achievementseyebrow1(inputs)
	if (locale === "uk") return uk_sandboxes_achievementseyebrow1(inputs)
	if (locale === "ar") return ar_sandboxes_achievementseyebrow1(inputs)
	if (locale === "hi") return hi_sandboxes_achievementseyebrow1(inputs)
	if (locale === "th") return th_sandboxes_achievementseyebrow1(inputs)
	if (locale === "ja") return ja_sandboxes_achievementseyebrow1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_achievementseyebrow1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_achievementseyebrow1(inputs)
	return ko_sandboxes_achievementseyebrow1(inputs)
});
export { sandboxes_achievementseyebrow1 as "sandboxes.achievementsEyebrow" }